import './sass/main.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import { Login } from './pages/authentication/Login';
import { ResetPassword } from './pages/authentication/ResetPassword';
import { SetNewPassword } from './pages/authentication/setNewPassword';
import { AppLayout } from './containers/dashboard/AppLayout';
import { Error } from './pages/dashboard/Error';
import { FAQ } from './pages/dashboard/FAQ';
import { DashboardContainer } from './containers/dashboard/DashboardContainer';
import { UsersContainer } from './containers/users/UsersContainer';
import { CompaniesContainer } from './containers/companies/CompaniesContainer';
import { ProcessesContainer } from './containers/processes/ProcessesContainer';
import { TrainingContainer } from './containers/training/TrainingContainer';
import { SettingsContainer } from './containers/settings/SettingsContainer';
import { TrainDocumentContainer } from './containers/training/TrainDocumentContainer';
import { ManageDocument } from './components/zahtjevi/ManageDocument';
import { useAppSelector } from './store/hooks/hooks';
import { StatisticsComponent } from './pages/dashboard/Statistics';
export const App = () => {
  const korisnik = useAppSelector((state) => state.korisnik);

  return (
    <BrowserRouter>
      <Routes>
        {korisnik.id ? (
          <Route path='/' element={<AppLayout />}>
            <Route index element={<DashboardContainer />} />
            <Route path='manageDocument' element={<ManageDocument />} />
            <Route path='stats' element={<StatisticsComponent />} />
            <Route path='companies' element={<CompaniesContainer />} />
            <Route path='users' element={<UsersContainer />} />
            <Route path='processes' element={<ProcessesContainer />} />
            <Route path='training' element={<TrainingContainer />} />
            <Route path='training/trainDocument' element={<TrainDocumentContainer />} />
            <Route path='FAQ' element={<FAQ />} />
            <Route path='settings' element={<SettingsContainer />} />
            <Route path='login' element={<Navigate to='/' />} />
          </Route>
        ) : (
          <>
            <Route path='/' element={<Landing />} />
            <Route path='login' element={<Login />} />
            <Route path='resetPassword' element={<ResetPassword />} />
            <Route path='setNewPassword' element={<SetNewPassword />} />
            <Route path='*' element={<Navigate to='/login' />}></Route>
          </>
        )}
        <Route path='*' element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};
